import React, { useState } from "react";

import './payemntSwitcher.scss';
import {withTranslation} from "react-i18next";
import PaymentTypeBlock from "./PaymentTypeBlock";

const PaymentSwitcher = ({currentPaymentType, setCurrentPaymentType, t, paymentTypes}) => {

  const selectPaymentType = (paymentType) => {
    setCurrentPaymentType(paymentType);
  };

  return (
    <div className={'payment-switcher-block'}>
      <div className={'payment-types'}>
        {
          paymentTypes.map(payment => (
            <PaymentTypeBlock
              paymentType={ payment }
              selectPaymentType={ selectPaymentType }
              currentPaymentType={ currentPaymentType }
            />
          ))
        }
      </div>
    </div>
  );
};

export default withTranslation()(PaymentSwitcher);
